import React, { useState, useEffect } from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { year } from '../../../modules/dates';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import Styles from './styles';

import LinkContainer from '../../containers/LinkContainer';

const { copyrightStartYear } = Meteor.settings.public;

const copyrightYear = () => {
  const currentYear = year();
  return currentYear === copyrightStartYear
    ? copyrightStartYear
    : `${copyrightStartYear}-${currentYear}`;
};

const Footer = ({ positionRelative }) => {
  const [version, setVersion] = useState('1');
  useEffect(() => {
    async function getVersion() {
      try {
        const appVersion = await methodPromise('app.getVersion');
        setVersion(appVersion);
      } catch (error) {
        handleErrorInClient(error);
      }
    }
    getVersion();
  }, [version]);
  return (
    <Styles.Footer positionRelative={positionRelative}>
      <Container fluid>
        <Navbar className="px-0">
          <Navbar.Text className="d-inline mr-1">
            {`v${version}`} &copy; {`${copyrightYear()} developed by`}
          </Navbar.Text>
          <Navbar.Brand
            className="d-inline mr-auto"
            href="https://www.srmconsulting.es"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              className="d-inline-block"
              src="/ias-logo/srm.png"
              height="30px"
              alt="SRM Consulting"
            />
          </Navbar.Brand>
          <Nav>
            <LinkContainer to="/terms">
              <Nav.Link>
                Terms
                <span className="d-none d-sm-inline"> of Service</span>
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/privacy">
              <Nav.Link>
                Privacy
                <span className="d-none d-sm-inline"> Policy</span>
              </Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar>
      </Container>
    </Styles.Footer>
  );
};

Footer.defaultProps = {
  positionRelative: false
};

Footer.propTypes = {
  positionRelative: PropTypes.bool
};

export default Footer;
